export enum UploadProgressStatus {
	SUCCESS = "success",
	ERROR = "exception",
	LOADING = "active"
}
